import { usePermissions } from '~/composables/usePermissions'
import { usePermissionStore } from '~/stores/permissions'
import { useAuthStore } from '~/stores/auth'

/**
 * Route middleware for permission-based access control
 * 
 * Usage in page components:
 * definePageMeta({
 *   middleware: 'permission',
 *   permission: {
 *     resourceType: 'app',
 *     action: 'create'
 *   }
 * })
 */
export default defineNuxtRouteMiddleware(async (to, from) => {
  // Skip middleware if no permission requirements
  if (!to.meta.permission) {
    return
  }
  
  const authStore = useAuthStore()
  const permissionStore = usePermissionStore()
  const { hasPermission } = usePermissions()
  
  // If not authenticated, redirect to login
  if (!authStore.isAuthenticated) {
    return navigateTo('/login')
  }
  
  // Ensure permissions are loaded
  if (!permissionStore.isInitialized) {
    await permissionStore.initPermissions()
  }
  
  const { resourceType, action } = to.meta.permission as { resourceType: string, action: string }
  
  // Check if user has required permission
  if (!hasPermission(resourceType, action)) {
    // Redirect to unauthorized page or home page
    console.error(`Permission denied: ${action} ${resourceType}`)
    return navigateTo('/unauthorized')
  }
})
